import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import CreateSaq from "../../components/CreateSaq";

import { images } from "../../helpers/images";

import {
  callApiSaqsFind,
  callApiUsersList,
  callApiBusinessesList,
} from "../../services";
import { authUserData } from "../../helpers";
import SaqLists from "../../components/SaqLists";
import Header from "../../components/Header";
import BusinessAdminHeader from "../../components/BusinessAdminHeader";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      userData: null,
      totalUsers: 0,
      totalBusinesses: 0,
      totalBusinesses: 0,
      draftSaqData: 0,
      completedSaqData: 0,
      showModal: false,
      businessId: null,
      isBusinessAdmin: false,
      subdomain: null,
    };
  }

  componentDidMount = async () => {
    const userData = authUserData();

    console.log("M userData", userData);

    if (userData && userData.isAdmin && userData.isAdmin === true) {
    } else {
    }

    const hostname = window.location.hostname;

    // Split by dots
    const parts = hostname.split(".");

    // Get the subdomain (first part)
    const subdomain = parts[0];

    //console.log("subdomain", subdomain);

    let currentBusinessId;

    // console.log("useData Dashboard", userData);

    if (userData) {
      this.setState({
        subdomain,
        userData,
      });
    }

    if (userData && userData.isAdmin && userData.isAdmin === true) {
      currentBusinessId = null;
    } else {
      const tempBusinessDetails =
        userData &&
        userData.businessDetails &&
        userData.businessDetails.length > 0 &&
        userData.businessDetails.filter((v, i) => {
          return v.primaryUser === true && v.userType === "admin" && v;
        });

      if (tempBusinessDetails && tempBusinessDetails.length == 0) {
        this.props.history.push("/dashboard/");
        return;
      }

      currentBusinessId = tempBusinessDetails[0].businessId;

      // console.log("tempBusinessDetails", tempBusinessDetails[0].businessId);

      this.setState(
        {
          businessId: tempBusinessDetails[0].businessId,
          isBusinessAdmin: true,
        },
        () => {
          // console.log("B ID", this.state.businessId);
        }
      );
    }

    /* callApiBusinessesList({})
      .then((res) => {
        console.log("business", res);
        if (res.success && res.data && res.data.length > 0) {
          this.setState({
            totalBusinesses: res.data.length,
          });
        }
      })
      .catch((error) => {
        console.log("Business API ERROR");
      }); */

    callApiUsersList({ businessId: currentBusinessId })
      .then((res) => {
        // console.log("0000. 000000 ", res);
        if (res.success && res.data && res.data.length > 0) {
          this.setState({
            totalUsers: res.data.length,
          });
        }
      })
      .catch((error) => {});

    let saqsApiParam = null;

    console.log("Dashboard - subdomain:", subdomain);
    console.log("Dashboard - userData.isAdmin:", userData && userData.isAdmin);

    // If admin user is on the main "app" subdomain, show all SAQs
    // If admin user is on a specific business subdomain, show only that business's SAQs
    // If business admin, show only their business's SAQs
    if (userData && userData.isAdmin && userData.isAdmin === true && subdomain === "app") {
      saqsApiParam = {}; // Empty query to get all SAQs
      console.log("Dashboard - Using empty query for admin on app subdomain");
    } else {
      saqsApiParam = { subdomain: subdomain }; // Filter by subdomain
      console.log("Dashboard - Using subdomain filter:", saqsApiParam);
    }

    callApiSaqsFind(saqsApiParam)
      .then((res) => {
        // console.log("api res mmmmm", res);
        if (res.success && res.data) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });
          // console.log("completedList", completedList.length);

          this.setState({
            draftSaqData: draftList.length,
            completedSaqData: completedList.length,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  makeTempPassword(length) {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()-=";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("");
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    // console.log("closing Modal!");
    this.setState({ showModal: false });
  };

  render() {
    const { history } = this.props;
    const {
      userData,
      draftSaqData,
      completedSaqData,
      showModal,
      totalUsers,
      totalBusinesses,
      businessId,
      isBusinessAdmin,
    } = this.state;

    return (
      <div className="cell small-12 medium-10" id="maincontent">
        {userData && !userData.isAdmin && (
          <BusinessAdminHeader isBusinessAdmin={isBusinessAdmin} />
        )}

        <ToastContainer />
        <div id="body-content">
          <div className="grid-x  grid-margin-x grid-margin-y">
            <div id="notification" className="cell small-12 medium-12">
              <div id="notification-content">
                {userData && userData.isAdmin && <h3>Super Admin Dashboard</h3>}

                {isBusinessAdmin === true && <h3>Dashboard</h3>}

                {/* <p>If you are not sure which SAQ to take click saq wizard.</p> */}
              </div>
              {/* <Link to="/create/wizard" className="button create-button">
                SAQ Wizard <span id="plus-icn"></span>
              </Link> */}
            </div>
          </div>

          <div id="button-link" className="grid-x  grid-margin-x grid-margin-y">
            <div className="cell small-12 medium-12">
              <div className="grid-x grid-margin-x  small-up-12 medium-up-3">
                {/* <div className="cell link-saq current" id="link-saq-a">
                  <Link to="/control-panel/companies">
                    <span className="txt-small">Total Companies</span>
                    {totalBusinesses}
                  </Link>
                </div> */}

                <div className="cell link-saq current" id="link-saq-a">
                  <Link to={`/control-panel/users`}>
                    <span className="txt-small">Active Users</span>
                    {totalUsers}
                  </Link>
                </div>

                <div className="cell link-saq current" id="link-saq-a">
                  <Link to="/control-panel/completed-saqs">
                    <span className="txt-small">Total Completed SAQs</span>
                    {completedSaqData}
                  </Link>
                </div>

                <div className="cell link-saq current" id="link-saq-a">
                  <Link to="/control-panel/draft-saqs">
                    <span className="txt-small">Total Draft SAQs</span>
                    {draftSaqData}
                  </Link>
                </div>

                {/* <div className="cell link-saq" id="link-saq-a">
                  <Link to="/create/saq-a">
                    <span className="txt-small">CREATE New</span>
                    SAQ-A
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-aep">
                  <Link to="/create/saq-a-ep">
                    <span className="txt-small">CREATE New</span>
                    SAQ A-EP
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-b">
                  <Link to="/create/saq-b">
                    <span className="txt-small">CREATE New</span>
                    SAQ B
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="cell small-12 medium-12">
              <div className="grid-x grid-margin-x small-up-12 medium-up-4">
                {/* <div className="cell link-saq" id="link-saq-a">
                  <Link to="/create/saq-b-ip">
                    <span className="txt-small">CREATE New</span>
                    SAQ B-IP
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-c">
                  <Link to="/create/saq-c">
                    <span className="txt-small">CREATE New</span>
                    SAQ-C
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-dme">
                  <Link to="/create/saq-d-me">
                    <span className="txt-small">CREATE New</span>
                    SAQ D-ME
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-dsp">
                  <Link to="/create/saq-d-sp">
                    <span className="txt-small">CREATE New</span>
                    SAQ D-SP
                  </Link>
                </div> */}

                {/* <div className="cell link-saq saqwizard" id="link-saq-bip">
                  <Link to="/create/wizard">
                    <img src={images.wizard} />
                    SAQ WIZARD
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
